import React, {Component} from 'react';
import './ShepherdTour.css'

const Shepherd = window.Shepherd;

class ShepherdTour extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    constructor(props) {
        super(props);

        this.version = '2.12';
    }

    async componentDidMount() {
        await this.createTour();
    }

    componentWillReceiveProps(nextProps) {
        const oldPathname = this.props.location.pathname;
        const newPathname = nextProps.location.pathname;

        if (oldPathname !== newPathname && this.tour)
            this.tour.cancel();
    }

    async componentDidUpdate() {
        await this.createTour();
    }

    componentWillUnmount() {
        if (this.tour)
            this.tour.cancel();
    }

    render() {
        return (
            <div/>
        );
    }

    async createTour() {
        let pathname = this.props.location.pathname;

        if (!this.pages) {
            let response = await fetch(`/shepherd/${this.version}.json`);
            this.pages = await response.json();
        }

        let page = this.pages.find(page => page.path === pathname);
        if (!page)
            return;

        let steps = page.steps;

        this.tour = new Shepherd.Tour({
            defaults: {
                classes: '',
                scrollTo: false
            }
        });

        steps.forEach((step, i) => {
            let name = `step-${i}`,
                isLast = i === steps.length - 1;

            this.createStep(this.tour, name, step.selector, step.text, isLast);
        });

        this.tour.start();
    }

    createStep(tour, name, selector, text, isLast = false) {
        let buttons = isLast
            ? [
                {
                    text: 'Отлично!',
                    classes: 'btn btn-primary',
                    action: tour.next
                }
            ]
            : [
                {
                    text: 'Не интересно',
                    classes: 'btn btn-default',
                    action: tour.cancel
                },
                {
                    text: 'Понял',
                    classes: 'btn btn-primary',
                    action: tour.next
                }
            ];

        tour.addStep(name, {
            text: text,
            attachTo: selector,
            classes: 'shepherd shepherd-open popover popover-content',
            buttons: buttons
        });
    }
}

export default ShepherdTour;


// WEBPACK FOOTER //
// ./src/components/ShepherdTour.js